<template>
    <v-form class="card-check" @submit.prevent="checkCard()">
        <p class="card-check__hint">
            Εισάγετε τον αριθμό της κάρτας και τα αρχικά σας, όπως είναι τυπωμένα στην κάρτα
            <span class="card-check__example">π.χ. ΧΧΧΧΧΧ / ΧΧ - ΔΑ</span>
        </p>
        <div class="card-check__fields">
            <v-text-field
                v-model="cardNumber"
                label="Αριθμός κάρτας"
                maxlength="6"
                inputmode="numeric"
                outlined
                hide-details
                class="card-check__number"
            />
            <span class="card-check__sep">/</span>
            <v-text-field
                v-model="cardSequence"
                label="Σειρά"
                outlined
                hide-details
                class="card-check__short"
            />
            <span class="card-check__sep">-</span>
            <v-text-field
                v-model="cardInitials"
                label="Αρχικά"
                maxlength="2"
                outlined
                hide-details
                class="card-check__short"
            />
        </div>
        <div class="card-check__note">Η «Σειρά» συμπληρώνεται μόνο αν υπάρχει στην κάρτα σας.</div>
        <v-alert v-if="error" type="error" text dense class="mt-4 mb-0 text-left">{{ error }}</v-alert>
        <v-btn
            type="submit"
            depressed
            block
            x-large
            color="#1b2f5a"
            dark
            class="mt-5"
            :loading="loading"
        >
            Είσοδος
        </v-btn>
    </v-form>
</template>   

<script>
import restApi from "@/rest-api"

export default {
    data() {
        return {
            cardNumber: null,
            cardSequence: null,
            cardInitials: null,
            loading: false,
            error: null
        }
    },
    computed: {
        language() {
            return this.$store.getters.getLanguage.language
        }
    },
    methods: {
        checkCard() {
            // always the card typed in the form: this used to send the remembered card instead,
            // so logging in with another card logged the previous member in again
            var card = (this.cardNumber || '').trim()+(this.cardSequence ? '/'+this.cardSequence.trim() : '')
            var initials = (this.cardInitials || '').trim()
            this.error = null
            if (!card || !initials) {
                this.error = 'Συμπληρώστε τον αριθμό της κάρτας και τα αρχικά σας.'
                return
            }
            var filter = {
                "number": card,
                "initials": initials
            }
            this.loading = true
            var search = `/card/filtered`
            restApi
            .post(search, filter)
            .then(response => {
                this.$store.dispatch('clearSession')
                this.$store.dispatch("setCard", response.data[0].number)
                let memberInfo = response.data[0].member.firstName.charAt(0) + response.data[0].member.lastName.charAt(0)
                this.$store.dispatch("setFirstName", response.data[0].member.firstName)
                this.$store.dispatch("setLastName", response.data[0].member.lastName.replace('-',''))
                this.$store.dispatch("setInitials", memberInfo)
                this.$store.dispatch("setParonMember", response.data[0])
                this.$store.dispatch("setExpirationDate", response.data[0].expirationDate)
                this.$emit('showSecret')
                if (this.$route.name !== 'Profile') {
                    this.$router.push({name: 'Profile'})
                }
            })
            .catch((error) => {
                this.error = this.loginError(error)
            })
            .finally(() => {
                this.loading = false
            });
      },
      loginError(error) {
        const status = error.response && error.response.status
        const message = (error.message || '').toLowerCase()
        if (status === 404) {
            return 'Δεν βρέθηκε κάρτα με αυτόν τον αριθμό. Ελέγξτε τον αριθμό και τον αριθμό σειράς μετά την κάθετο.'
        }
        if (message.includes('initials')) {
            return 'Τα αρχικά δεν αντιστοιχούν στην κάρτα. Πληκτρολογήστε τα αρχικά του ονόματος και του επωνύμου σας.'
        }
        if (status === 429) {
            return 'Πάρα πολλές αποτυχημένες προσπάθειες. Δοκιμάστε ξανά σε 15 λεπτά.'
        }
        if (message.includes('not active')) {
            return 'Η κάρτα δεν είναι ενεργή. Επικοινωνήστε μαζί μας στο 2109852175.'
        }
        if (status === 400) {
            return 'Συμπληρώστε τον αριθμό της κάρτας και τα αρχικά σας.'
        }
        return 'Δεν ήταν δυνατή η σύνδεση. Δοκιμάστε ξανά σε λίγο.'
      },
    }
}
</script>

<style scoped>
.card-check__hint {
    margin: 0 0 18px;
    color: rgba(27, 47, 90, 0.8);
    line-height: 1.5;
}

.card-check__example {
    display: block;
    margin-top: 4px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #1b2f5a;
}

.card-check__fields {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-check__number {
    flex: 2 1 0;
}

.card-check__short {
    flex: 1 1 0;
}

.card-check__sep {
    font-size: 22px;
    color: rgba(27, 47, 90, 0.5);
}

@media (max-width: 599px) {
    .card-check__fields {
        flex-wrap: wrap;
    }

    .card-check__number {
        flex-basis: 100%;
    }

    .card-check__fields .card-check__sep:first-of-type {
        display: none;
    }
}

.card-check__note {
    margin-top: 8px;
    font-size: 13px;
    color: rgba(27, 47, 90, 0.65);
    text-align: left;
}
</style>
